import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { createForm, FormType, subformComponentProviders } from 'ngx-sub-form';
import { PoreFrac } from 'src/app/perivis/models/poreFrac.model';
import { CirculatedKickGasIPP, InternalPressureProfileType } from '../../models/internal-pressure-profile.model';
import { UomQuantityInput } from '../../uom-quantity-input/uom-quantity-input-component';
import { UserUnitsModel } from 'src/app/core/components/user-units/user-units.model';
import { WellComponent } from 'src/app/wellbore-inputs/components/well-configuration/models';
import { InfluxFracDepthBaseComponent } from '../gas-influx/influx-frac-depth-base/influx-frac-depth-base.component';

interface CirculatedKickGasIppForm {
  type: InternalPressureProfileType.GASKICK;
  influxDepth: UomQuantityInput;
  gasGravity: UomQuantityInput;
  kickVolume: UomQuantityInput;
  kickIntensity: UomQuantityInput;
  maxMudWeight: UomQuantityInput;
  fractureDepth: UomQuantityInput;
  fractureGradient: UomQuantityInput;
  fractureMarginOfError: UomQuantityInput;
  drillPipeOd: UomQuantityInput;
}

@Component({
  selector: 'app-circulated-kick-gas-ipp',
  templateUrl: './circulated-kick-gas-ipp.component.html',
  providers: subformComponentProviders(CirculatedKickGasIppComponent),
  standalone: false
})
export class CirculatedKickGasIppComponent implements AfterViewInit {
  @Input() currentString: any;
  @Input() nextStringMudWeight: number;
  @Input() smallestPipeId: number;
  @Input() fracPressures: PoreFrac[];
  @Input() userUnits: UserUnitsModel;
  @Input() influxDepthRange: { min: number, max: number };
  @Input() tubulars: WellComponent[];
  @Input() fractureDepthDefault: number;
  
  @ViewChild(InfluxFracDepthBaseComponent) influxFracDepthBase!: InfluxFracDepthBaseComponent;

  public form = createForm<CirculatedKickGasIPP, CirculatedKickGasIppForm>(this, {
    formType: FormType.SUB,
    formControls: {
      type: new UntypedFormControl(InternalPressureProfileType.GASKICK),
      influxDepth: new UntypedFormControl(null),
      gasGravity: new UntypedFormControl(null),
      kickVolume: new UntypedFormControl(null),
      kickIntensity: new UntypedFormControl(null),
      maxMudWeight: new UntypedFormControl(null),
      fractureDepth: new UntypedFormControl(null),
      fractureGradient: new UntypedFormControl(null),
      fractureMarginOfError: new UntypedFormControl(null),
      drillPipeOd: new UntypedFormControl(null),
    },
    toFormGroup: (obj: CirculatedKickGasIPP | null): CirculatedKickGasIppForm | null => {
      if (!obj) {
        return null
      }

      return {
        type: obj.type,
        influxDepth: { control: obj.influxDepth },
        gasGravity: { control: obj.gasGravity },
        kickVolume: { control: obj.kickVolume },
        kickIntensity: { control: obj.kickIntensity },
        maxMudWeight: { control: obj.maxMudWeight },
        fractureDepth: { control: obj.fractureDepth },
        fractureGradient: { control: obj.fractureGradient },
        fractureMarginOfError: { control: obj.fractureMarginOfError },
        drillPipeOd: { control: obj.drillPipeOd }
      }
    },
    fromFormGroup: (formValue: CirculatedKickGasIppForm): CirculatedKickGasIPP | null => {
      const { influxDepth, gasGravity, kickVolume, kickIntensity, maxMudWeight, fractureDepth, fractureGradient, fractureMarginOfError, drillPipeOd, ...commonValues } = formValue;
      return {
        influxDepth: +influxDepth?.control,
        gasGravity: +gasGravity?.control,
        kickVolume: +kickVolume?.control,
        kickIntensity: +kickIntensity?.control,
        maxMudWeight: +maxMudWeight?.control,
        fractureDepth: +fractureDepth?.control,
        fractureGradient: +fractureGradient?.control,
        fractureMarginOfError: +fractureMarginOfError?.control,
        drillPipeOd: +drillPipeOd?.control,
        ...commonValues
      }
    }
  });

  ngAfterViewInit(): void {
    this.influxFracDepthBase.getEmwDefaultFrac(this.influxDepthRange.max, this.influxFracDepthBase.fractureDepthDefault, false, false);
  }
}
